import { render, staticRenderFns } from "./AreaHome.vue?vue&type=template&id=cb11af44&scoped=true&"
import script from "./AreaHome.vue?vue&type=script&lang=js&"
export * from "./AreaHome.vue?vue&type=script&lang=js&"
import style0 from "./AreaHome.vue?vue&type=style&index=0&id=cb11af44&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb11af44",
  null
  
)

export default component.exports